import '../styles/sites1-5/main.scss';
import "./counters";
import "./cookie";
import "./elements/faq";
import {unsubscribeLogic} from "./unsubscribe";
import {paymentLogic} from "./paymentPagesLogic";
import {scrollLogic} from "./scrollLogic";
import {loginPageLogic} from "./login";
import {contactFormLogic} from "./contactForm";
import "./elements/header";
import {pricingSwitchersLogic} from "./elements/pricingSwitchersLogic";
// import "./elements/popups"; // not used

[].slice.call(document.querySelectorAll(" .ui-accordion")).forEach(function (parent) {
  var allElements = [].slice.call(parent.querySelectorAll(".ui-accordion__item"));
  allElements.forEach(element => {
    element.onclick = function (event) {
      if (element.dataset.id === event.target.dataset.id) {
        element.classList.contains("ui-accordion__item--active")
          ? element.classList.remove("ui-accordion__item--active")
          : element.classList.add("ui-accordion__item--active")
      } else {
        element.classList.remove("ui-accordion__item--active")
      }
    }
  })
});

document.addEventListener("DOMContentLoaded", () => {

  // footer -disclaimer fix

  if (document.querySelector(".section--disclaimer")) {
   const footer = document.querySelector(".footer");
   if (footer) {
     footer.classList.add("footer--with-disclaimer");
   }
  }

  pricingSwitchersLogic();
  scrollLogic();
  unsubscribeLogic();
  paymentLogic();
  loginPageLogic();
  contactFormLogic();

  console.log('Common script is loaded');
});